export default __webpack_public_path__ + "static/file-to-data-c6b46fb4776375b0382eff8140512ff6.gif";